import React from "react";
import style from "./Style.module.css";

export const ConfirmationPopup = (props) => {
  const {
    title,
    action,
    setConfirmationModal,
    handleDelete,
    handleEndOffer,
    loading,
  } = props;
  const confirmLabel = loading
    ? "Please wait…"
    : action === "End Offer"
    ? "End Offer"
    : "Delete";
  return (
    <div className={style.confirmationContainer}>
      <div className={style.confirmationtitle}>{title}</div>
      {(action === "Delete" || action === "End Offer") && (
        <div className={style.confirmbuttonContainer}>
          <button
            className={style.confirmdelete}
            disabled={loading}
            onClick={
              action === "Delete"
                ? handleDelete
                : action === "End Offer"
                ? handleEndOffer
                : null
            }
          >
            {confirmLabel}
          </button>
          <button
            className={style.confirmcancel}
            disabled={loading}
            onClick={() => setConfirmationModal(false)}
          >
            Cancel
          </button>
        </div>
      )}
    </div>
  );
};
